const $ = require('jquery');
let selector = $('main');
let query = $.parseJSON(selector.attr('data-query'));
let currentRoute = selector.attr('data-route');
const lang = document.documentElement.lang;
import {Router} from './router';

export const initRelatedTags = () => {
    let url = currentRoute === 'look_search'
        ? Router.generate('look_similar_tags.' + lang)
        : Router.generate('streetstyle_similar_tags.' + lang);
    if (query.tags !== undefined) {
        let esc = encodeURIComponent;
        let params = Object.keys(query)
            .map(k => esc(k) + '=' + (query[k] ? esc(query[k]) : ''))
            .join('&');
        fetch(url + '?' + params, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then(function (response) {
            response.json().then(function (data) {
                if (data.length > 0) {
                    loadRelatedTags(data)
                }
            })
        });
    }
}

function loadRelatedTags(data) {
    $('.tags-similars').show()
    let delimiter = ' | ';
    if (query.hasOwnProperty('individuals')) {
        query['individual'] = query['individuals'];
        delete (query['individuals'])
    }
    let tagsSimilarsProto = $('.tag-link-proto');
    data = removeDulicatedTags(data)
    for (let i = 0; i < data.length; i++) {
        let tagsSimilars = tagsSimilarsProto.clone()
        query['tags'] = data[i]['slug'];
        tagsSimilars
            .attr('href', Router.generate(currentRoute + '.' + lang, query))
            .appendTo('.tags-similars')
            .removeClass('tag-link-proto')
            .addClass('tag-link')
            .html(data[i]['name'] + (i === data.length - 1 ? '' : delimiter))
    }
    tagsSimilarsProto.remove()
}

function removeDulicatedTags(data) {
    let result = [];
    let currentTagsInQuery = query['tags'].split(',');
    //TODO refactoring
    let uniqueSimilars = [
        ...new Map(
            data.map(item => [
                item['name'],
                item
            ])).values()
    ];
    uniqueSimilars.forEach(function (similars) {
        if (currentTagsInQuery.find(item => item === similars.slug) === undefined) {
            result.push({'name': similars.name, 'slug': similars.slug})
        }
    });

    return result
}
